import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const updateNotification = async (id) => {
    await axios.put(`/notification/updateadminnotification/${id}`, null);
}

export const updateAdminNotification = async (id) => {
    await axios.put(`/notification/updateadminnotification/${id}`, null);
}

export const getAllNotifications = async (userId, userType, callback) => {
    const res = await axios.get(`/notification/?userId=${userId}&userType=${userType}`);
    if (res.status === 200) {
        const notificationList = res.data.response.data||[];
        callback(notificationList)
    } else {
        callback(res.data.response);
    }
}

export const getAllAdminNotifications = async (callback) => {
    const res = await axios.get(`/notification/adminnotification`);
    if (res.status === 200) {
        const notificationList = res.data.response.data;
        callback(notificationList)
    } else {
        callback(res.data.response);
    }
}


export const NotificationAPI = () => {
    const [notifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState();
    const [adminNotifications, setAdminNotifications] = useState([]);
    const [adminNotificationCount, setAdminNotificationCount] = useState(0);

    const [userId, setUserId] = useState(0);
    const [userType, setUserType] = useState("");
    const [callback, setCallback] = useState(false);

    const isUser=localStorage.getItem("login");

    useEffect(() => {
        if(!isUser) return ;
        const fetchData=async()=>{
            try {
                if(userId){
                    const NotificationData=await new Promise((resolve)=>
                        getAllNotifications(userId, userType,resolve)
                    );
                    setNotifications(NotificationData.data);
                    setNotificationCount(NotificationData.count || 0)
                }
    
                const notificationList=await new Promise((resolve)=>getAllAdminNotifications(resolve));
                setAdminNotifications(notificationList.data);
                setAdminNotificationCount(notificationList.count || 0);
            } catch (err) {
                console.error("Error fetching notification: ",err)
            }
        };

        fetchData();
    }, [callback, userId, userType,isUser])

    return {
        notifications: [notifications, setNotifications],
        notificationCount: [notificationCount, setNotificationCount],
        adminNotifications: [adminNotifications, setAdminNotifications],
        adminNotificationCount: [adminNotificationCount, setAdminNotificationCount],
        userId: [userId, setUserId],
        userType: [userType, setUserType],
        callback: [callback, setCallback]
    }
}
